import { isAllowedLiabilityType as isAllowedLiabilityTypeBase } from '@homevest/utils/liability-types'
import type { AllowedLiabilityTypeInput } from '@homevest/utils/liability-types'

export const isAllowedLiabilityType = (liabilityType: AllowedLiabilityTypeInput) =>
  isAllowedLiabilityTypeBase(liabilityType, {
    ccFeeLiabilityTypeId: process.env.REACT_APP_CC_FEE_LIABILITY_TYPE_ID!
  })
